var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarpet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m376 102.153h-240c-8.284 0-15 6.716-15 15v277.694c0 8.284 6.716 15 15 15h240c8.284 0 15-6.716 15-15v-277.694c0-8.284-6.716-15-15-15zm-15 277.694h-210v-247.694h210z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m451 15c0-8.284-6.716-15-15-15s-15 6.716-15 15v27.153h-30v-27.153c0-8.284-6.716-15-15-15s-15 6.716-15 15v27.153h-30v-27.153c0-8.284-6.716-15-15-15s-15 6.716-15 15v27.153h-30v-27.153c0-8.284-6.716-15-15-15s-15 6.716-15 15v27.153h-30v-27.153c0-8.284-6.716-15-15-15s-15 6.716-15 15v27.153h-30v-27.153c0-8.284-6.716-15-15-15s-15 6.716-15 15v27.153h-30v-27.153c0-8.284-6.716-15-15-15s-15 6.716-15 15v482c0 8.284 6.716 15 15 15s15-6.716 15-15v-27.153h30v27.153c0 8.284 6.716 15 15 15s15-6.716 15-15v-27.153h30v27.153c0 8.284 6.716 15 15 15s15-6.716 15-15v-27.153h30v27.153c0 8.284 6.716 15 15 15s15-6.716 15-15v-27.153h30v27.153c0 8.284 6.716 15 15 15s15-6.716 15-15v-27.153h30v27.153c0 8.284 6.716 15 15 15s15-6.716 15-15v-27.153h30v27.153c0 8.284 6.716 15 15 15s15-6.716 15-15zm-360 57.153h330v367.694h-330z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m245.394 326.076c2.929 2.929 6.768 4.393 10.606 4.393s7.678-1.464 10.606-4.393l59.47-59.47c5.858-5.858 5.858-15.355 0-21.213l-59.47-59.47c-5.857-5.858-15.355-5.858-21.213 0l-59.47 59.47c-5.858 5.858-5.858 15.355 0 21.213zm10.606-108.332 38.257 38.256-38.257 38.256-38.257-38.256z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarpet);
export default __webpack_public_path__ + "static/media/carpet.3a429103c44df4e16963abff631af4f0.svg";
export { ForwardRef as ReactComponent };